/**
 * User Management feature flag constants.
 * Re-exported from the global FEATURE_FLAGS for module-local imports.
 */
import { FEATURE_FLAGS } from '@/common/domain/constants/featureFlags';

export const USER_MANAGEMENT_FEATURE_FLAGS = {
  /** Master kill switch — controls sidebar nav + all routes */
  USER_MANAGEMENT_PAGE: FEATURE_FLAGS.USER_MANAGEMENT_PAGE,
  /** Controls Roles tab visibility */
  USER_MANAGEMENT_ROLES: FEATURE_FLAGS.USER_MANAGEMENT_ROLES,
  /** Controls Approvals tab visibility */
  USER_MANAGEMENT_APPROVALS: FEATURE_FLAGS.USER_MANAGEMENT_APPROVALS,
  /** Controls Audit Log tab visibility */
  USER_MANAGEMENT_AUDIT: FEATURE_FLAGS.USER_MANAGEMENT_AUDIT,
  /** Gates delegation UI (header button, banners, admin row action) — TROC-178 */
  USER_MANAGEMENT_DELEGATION: FEATURE_FLAGS.USER_MANAGEMENT_DELEGATION,
  /** Controls Access Review tab (also requires AccessReview permission) — TROC-352 */
  USER_MANAGEMENT_QUARTERLY_REVIEW: FEATURE_FLAGS.USER_MANAGEMENT_QUARTERLY_REVIEW
} as const;
